<template>
    <article class="outer">
        <div id="slogan">
            <p>Control your Mac using your iOS device</p>
            <p>through USB or Bluetooth</p>
            <p>in a customizable UI.</p>
        </div>
        <IntroSwipe></IntroSwipe>
        <About></About>
        <img class="wallpaper lazyload" alt="" data-src="../assets/images/wallpaper_iphone_remote_control.jpeg"/>
        <CustomizeYourInterface></CustomizeYourInterface>
        <MechanicalKeyboardSound></MechanicalKeyboardSound>
        <img class="wallpaper lazyload" alt="" data-src="../assets/images/wallpaper_ipad_mini_numeric_keypad.jpeg"/>
        <TrackpadGestures></TrackpadGestures>
        <img class="wallpaper lazyload" alt="" data-src="../assets/images/wallpaper_iphone_trackpad.jpeg"/>
        <Requirements></Requirements>
    </article>
</template>

<script>
    import IntroSwipe from './IntroSwipe.vue'
    import About from './About.vue'
    import CustomizeYourInterface from './CustomizeYourInterface.vue'
    import MechanicalKeyboardSound from './MechanicalKeyboardSound.vue'
    import TrackpadGestures from './TrackpadGestures.vue'
    import Requirements from './Requirements.vue'

    export default {
        components: {
            IntroSwipe,
            About,
            CustomizeYourInterface,
            MechanicalKeyboardSound,
            TrackpadGestures,
            Requirements
        }
    }
</script>

<style>
    #slogan {
        padding-top: 110px;
        font-size: 32px;
        font-weight: 100;
        line-height: 1;
    }

    .wallpaper {
        max-width: 100%;
        width: 100%;
        border: none;
        margin: 0;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/MainContent.vue